module.exports = __webpack_public_path__ + "static/images/yxlm-img.dfdfd1c.png";